import { HIDE_ZONE_WITH_REGULATIONS_BUTTON,  SHOW_ZONE_WITH_REGULATIONS_BUTTON} from "./displayZoneWithRegulationsButtonReducer"

export const hideZoneWithRegulationsButton = () => ({
    type: HIDE_ZONE_WITH_REGULATIONS_BUTTON,
})

export const showZoneWithRegulationsButton = (data) => ({
    type: SHOW_ZONE_WITH_REGULATIONS_BUTTON,
    payload: data
})